import React, { useState } from 'react';
import axios from 'axios';
import { servicios_grupogack_rh, cambios_no_guardados } from '../../../../../../../Constants/Constants';
import { headersAuth } from '../../../../../../../Services/AuthService';
import { JsonMovimientosFijosEmpleado } from '../../../../Helpers/JsonToOneLevel';
import ModalService from '../../../../ModalService/ModalService';
import AlertForm from '../../../../../../../Services/AlertForm';
import FormularioFijos from './FormularioFijos';

const ModalEditFijos = ({ openEdit, setOpenEdit, elementSelect, editar, errorTable, informacionAdicional, idModulo }) => {
    const [ error, setError ] = useState( null );
    const cerrarModal = () => {
        setOpenEdit( false );
        setError( null );
    }

    const actualizarFijo = ( fijo, fijoID ) => {
        axios.put( `${servicios_grupogack_rh}/movimientos/fijo/${fijoID}`, fijo, headersAuth() )
            .then( respuesta => {
                switch( respuesta.data.status ){
                    case 200:
                        editar( JsonMovimientosFijosEmpleado( respuesta.data.dataResponse ) );
                        setOpenEdit( false );
                        break;
                    case 400:
                        setError( <AlertForm message={ respuesta.data.msg } /> );
                        break;
                    default:
                        errorTable( cambios_no_guardados );
                        break;
                }
            })
            .catch( error => {
                errorTable( cambios_no_guardados );
            })
    }

    return (
        <ModalService title="Actualizar Movimiento Fijo" parentNode={idModulo } minWidth="40%"
            isOpen={ openEdit } onClose={ () => cerrarModal() } >
                <FormularioFijos
                    error={error}
                    elementSelect={elementSelect}
                    informacion={informacionAdicional}
                    actualizarFijo={actualizarFijo}
                />
        </ModalService>
    );
};

export default ModalEditFijos;